import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  standalone: false,
  selector: 'campus-level-checkbox',
  templateUrl: './level-checkbox.component.html',
  styleUrls: ['./level-checkbox.component.scss'],
})
export class LevelCheckboxComponent {
  constructor() {}

  @Input()
  level: number;

  @Input()
  id: string;

  @Input()
  checked: boolean;

  @Input()
  disabled: boolean;

  @Input()
  indeterminate: boolean;

  @Output()
  change: EventEmitter<MatCheckboxChange> = new EventEmitter();

  handleChange(event) {
    this.change.emit(event);
  }
}
